<template>
  <div id="mySwiper" class="swiper-container mySwiper" keyboard="true" mousewheel="true" v-if="loggedUser">
    <div class="swiper-wrapper">
      <template v-for="(psychologists, index) in psychologistsArray" :key="index">
        <div class="swiper-slide">
          <psychologist-card :id="psychologists.psychologist_id" :title="psychologists.name"
            :imageUrl="psychologists.photo_url" :subtitle1="psychologists.description"
            :years_experience="psychologists.years_experience" :skills="psychologists.specialitiesNames"
            :individual_session_price="psychologists.individual_session_price"
            :couple_session_price="psychologists.couple_session_price" :audio="psychologists.audio" />
        </div>
      </template>      
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
  <div class="swiper-container mySwiper" id="mySwiper" v-else>
    <div class="swiper-wrapper">
      <div class="swiper-slide">
        <psychologist-card :id="1" :title="'Daniela Segura'" :imageUrl="dummyData.photo_url"
          :subtitle1="dummyData.description" :years_experience="dummyData.years_experience"
          :skills="dummyData.specialitiesNames" :individual_session_price="dummyData.individual_session_price"
          :couple_session_price="dummyData.couple_session_price" :audio="dummyData.audio" :dummy="true" :dummyId=1 />
      </div>
      <div class="swiper-slide">
        <psychologist-card :id="2" :title="'Gabriela Martinez'" :imageUrl="dummyData.photo_url"
          :subtitle1="dummyData.description" :years_experience="dummyData.years_experience"
          :skills="dummyData.specialitiesNames" :individual_session_price="dummyData.individual_session_price"
          :couple_session_price="dummyData.couple_session_price" :audio="dummyData.audio" :dummy="true" :dummyId=2 />
      </div>
      <div class="swiper-slide">
        <psychologist-card :id="3" :title="'Monica Durazo'" :imageUrl="dummyData.photo_url"
          :subtitle1="dummyData.description" :years_experience="dummyData.years_experience"
          :skills="dummyData.specialitiesNames" :individual_session_price="dummyData.individual_session_price"
          :couple_session_price="dummyData.couple_session_price" :audio="dummyData.audio" :dummy="true" :dummyId=3 />
      </div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>
 
<script>
import { useI18n } from 'vue-i18n'
import { computed, onMounted, ref, watch } from 'vue';
import PsychologistCard from '../../../components/PsychologistCard.vue'

import usePsycologistsOptions from '../composable/usePsycologistsOptions'
import { useStore } from 'vuex';
export default {
  components: {
    PsychologistCard
  },
  setup() {
    const store = useStore();
    const { t } = useI18n();
    const {      
      psychologistsArray,
      loading,
      dummyData,
      getCatalogs
    } = usePsycologistsOptions({});
    let mySwiper = null;
    const first = ref(true);
    const loggedUser = computed(() => store.getters['auth/getLoggedUser']); 

    const makeSwipper = () => {        
      mySwiper = new Swiper(".mySwiper", {
        slidesPerView: 1,
        spaceBetween: 15,

        // Navigation arrows
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },

        // cssMode: true,
        centerInsufficientSlides: true,
        // slideToClickedSlide: true,
        breakpoints: {
          640: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          992: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1500: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1900: {
            slidesPerView: 3,
            spaceBetween: 20,
          }
        },
      });
    }

    const makeSwipperEvents = () => {
      // Set event on slidechange
      mySwiper.on('slidechange', (event) => {
        // console.log('slide changed', event);        
      });

      mySwiper.on('progress', async (event) => {
        const progress = event.progress

        if (progress == 1) {
          if (!loading.value) {
            store.commit('setGeneralIsLoading', true);
            await getCatalogs();
            store.commit('setGeneralIsLoading', false);            
          }
        }
      });

      mySwiper.on('reachEnd', (event) => {
        // console.log('slide reachEnd', event);        
      });
    }

    onMounted(async() => {
      store.commit('setGeneralIsLoading', true);
      makeSwipper();
      makeSwipperEvents();
      store.commit('setGeneralIsLoading', false);      
    })

    watch(psychologistsArray, () => {
      if (mySwiper && first.value) {
        store.commit('setGeneralIsLoading', true);
        mySwiper.destroy();
        makeSwipper();
        makeSwipperEvents();
        first.value = false;
        store.commit('setGeneralIsLoading', false);
      } else {
        mySwiper.update();
        mySwiper.slideNext();
      }
    })

    return {
      psychologistsArray,
      dummyData,
      loading,
      loggedUser,
      t
    }
  }
}
</script>

<style scoped>
swiper-container {
  width: 100%;
  height: auto;
}

swiper-slide {
  text-align: center;
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
}

swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.psycologist-card {
  width: 100%;
  max-width: 440px;
  min-height: 618px;
  background-color: var(--white);
  padding: 15px 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0px 0px 6px #00000029;
  border-radius: 8px;
  margin: 0 auto;
}

.psycologist-card__profile-image {
  width: 115px;
  height: 115px;
  border-radius: 100px;
  margin: 0 auto 15px;
  object-fit: cover;
}

.psycologist-card__name {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.2;
}

.psycologist-card__profile,
.psycologist-card__experience {
  font-size: 18px;
  font-weight: 400;
  line-height: 1.2;
}

.psycologist-card__detail-buttons .btn {
  font-size: 14px;
  padding: 4px 12px;
  border-radius: 10px;
}

.psycologist-card__specialitiesNames-title {
  font-size: 16px;
  font-weight: 600;
}

.psycologist-card__specialitiesNames-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  height: auto;
  max-height: 150px;
  overflow-y: auto;

}

.skill-badge {
  line-height: 1;
  background-color: var(--ultra-light-light-blue);
  font-size: 12px;
  font-weight: 400;
  padding: 3px 6px;
  border-radius: 100px;
}

.costs-container {
  display: flex;
  justify-content: space-between;
  padding-bottom: 10px;
  border-bottom: 1px solid #287FF2;
}

.cost-title {
  display: block;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
  color: #5C9AD6;
}

.cost {
  display: inline-block;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  color: #5C9AD6;
  margin: 0;
}

.cost span {
  color: #3D74AD;
}

.btn-sherpa-medium-dark-blue {
  display: block;
  width: 80%;
  margin: 0 auto;
  border-radius: 8px;
}

#mySwiper {
  position: relative;
}

#mySwiper .swiper-button-lock {
  display: block !important;
}

/* #mySwiper .swiper-button-next.swiper-button-disabled {
  cursor: pointer !important;
  opacity: 1 !important;
  pointer-events: initial !important;
} */
</style>